import { User, defaultUser } from "./User";
import { Request } from "./Request";
import { TaskState } from "../features/task-feature";

export interface AppState {
  requests: Request[];
  user: User;
  tasks: TaskState;
}

export const initialState: AppState = {
  requests: [],
  user: defaultUser,
  tasks: {
    tasks: [],
    myTasks: [],
    totalCount: 0,
    isLoading: false
  }
};
